import { Building2, Box, Home as HomeIcon, Layers, Wrench, ClipboardCheck } from "lucide-react";

/**
 * Struttura dati centralizzata dei servizi.
 * Per aggiungere/modificare/sostituire una foto della galleria basta
 * modificare l'array `gallery` (max 10 URL).
 * es. "/gallery/progettazione/01.jpg" se caricate in /app/frontend/public/gallery/...
 */
export const SERVICES = [
  {
    slug: "progettazione-architettonica",
    icon: Building2,
    title_it: "Progettazione Architettonica",
    title_en: "Architectural Design",
    desc_it:
      "Progetti personalizzati per edifici residenziali e commerciali con attenzione ai dettagli e alle esigenze del cliente.",
    desc_en:
      "Tailored projects for residential and commercial buildings, with attention to detail and to the client's needs.",
    gallery: [], // max 10 – inserire qui gli URL delle foto reali
  },
  {
    slug: "spazio-dimostrativo",
    icon: Box,
    title_it: "Teatro Dinamico",
    title_en: "Dynamic Theater",
    desc_it:
      "Unico nel suo genere: uno spazio dove riprodurre la tua stanza in scala reale con blocchi mobili per visualizzare arredi e dimensioni.",
    desc_en:
      "One of a kind: a place where we reproduce your room at real scale with movable blocks to visualise furniture and dimensions.",
    gallery: [],
  },
  {
    slug: "design-d-interni",
    icon: HomeIcon,
    title_it: "Design d'Interni",
    title_en: "Interior Design",
    desc_it:
      "Soluzioni innovative per spazi interni che combinano funzionalità ed estetica, creando ambienti unici e armoniosi.",
    desc_en:
      "Innovative solutions for interior spaces that combine functionality and aesthetics, creating unique and harmonious environments.",
    gallery: [],
  },
  {
    slug: "consulenza-e-planimetrie",
    icon: Layers,
    title_it: "Consulenza e Planimetrie",
    title_en: "Consulting & Plans",
    desc_it:
      "Analisi dettagliata degli spazi e creazione di planimetrie tecniche con supporto completo nella fase di realizzazione.",
    desc_en:
      "In-depth analysis of the space and technical drawings with full support during execution.",
    gallery: [],
  },
  {
    slug: "ristrutturazioni",
    icon: Wrench,
    title_it: "Ristrutturazioni",
    title_en: "Renovations",
    desc_it:
      "Riqualificazione di edifici con soluzioni moderne che rispettano la struttura originale e migliorano gli spazi.",
    desc_en:
      "Refurbishment of existing buildings with modern solutions that respect the original structure and improve the spaces.",
    gallery: [],
  },
  {
    slug: "direzione-lavori-e-sicurezza",
    icon: ClipboardCheck,
    title_it: "Direzione Lavori e Sicurezza",
    title_en: "Site & Safety Management",
    desc_it:
      "Supervisione completa dei lavori di costruzione per garantire la qualità e il rispetto dei tempi e del budget concordati.",
    desc_en:
      "End-to-end supervision of construction works to guarantee quality and respect timelines and budget.",
    gallery: [],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
